<template>
  <div @click="$emit('click', $event)" class="cursor-pointer " >
    <img class="w-full" :src="currentPreview" alt="current label">
  </div>
</template>

<script>
export default {
  props: {
    currentPreview: {
      type: String,
      default: require('assets/images/cloudlabel.png')
    },

  }
}
</script>
